import { Component } from "vue-property-decorator";
import HacoBase from "./HacoBase";
@Component
export default class HacoCommonWithBase extends HacoBase {
  dialogText = "DIALOG";
  errorListText: string[] = [];
  confirmationText = "CONFIRMATION";
  dialogShows = false;
  confirmationShows = false;
  isErrorText = false;
  usingWaiter = false;
  dialogLock = false;
  mounted(): void {
    this.dialogText = "Changed";
    this.confirmationText = "Confirmation Changed";
  }
  putErrorList(arr: string[]): void {
    this.errorListText = arr;
  }
  putDialogText(str: string, waiter = false): void {
    this.dialogText = str;
    this.dialogShows = true;
    this.isErrorText = false;
    this.usingWaiter = waiter;
    this.dialogLock = waiter;
  }
  putErrorText(str: string): void {
    this.dialogText = str;
    this.dialogShows = true;
    this.isErrorText = true;
  }
  showSelections(str: string): void {
    this.confirmationText = str;
    this.confirmationShows = true;
  }
  hideDialog(): void {
    if (this.dialogLock === true) {
      return;
    }
    this.dialogShows = false;
    this.confirmationShows = false;
  }
}
